import type { AssignableItem } from 'pages/custom_tests_v1/components/assign_wizard/AssignWizard';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { useIntl } from 'react-intl';

import 'pages/custom_tests_v1/components/assign_wizard/components/selected_items_panel/styles/SelectedItemsPanel.scss';

type SelectedItemsPanelProps = {

	// Ids that were already assigned on the server — used to mark chips as "Assigned" vs "New".
	assignedIds?: number[];
	items: AssignableItem[];
	label?: string;
	onRemove: (item: AssignableItem) => void;
};

export const SelectedItemsPanel = (props: SelectedItemsPanelProps) => {

    const { assignedIds = [], items, label, onRemove } = props;

    const { formatMessage } = useIntl();

    const displayLabel = label ?? formatMessage({ id: 'selected.2c7e9011', defaultMessage: 'Selected' });

    return (
        <div className="border rounded p-3 bg-light">
            <div className="d-flex align-items-center mb-2">
                <span className="fw-bold">
                    {displayLabel}
                </span>
                <span className="badge bg-primary ms-2">
                    {items.length}
                </span>
            </div>

            {items.length === 0 ?
                (
                    <div className="text-muted fst-italic small py-1">
                        {formatMessage({ id: 'no_items_selected.61898483', defaultMessage: 'No items selected.' })}
                    </div>
                )
                :
                (
                    <div className="d-flex flex-wrap gap-2 selected-items-panel__chip-container">
                        {items.map((item, key) => {

                            const isAssigned = assignedIds.includes(item.Id);

                            return (
                                <span className={`d-inline-flex align-items-center bg-${isAssigned ? 'body-secondary' : 'white'} border rounded-pill px-2 py-1 small gap-2`} key={key}>
                                    {!isAssigned && (
                                    <span className={'badge bg-primary'}>
                                        {formatMessage({ id: 'new.03d9347f', defaultMessage: 'New' })}
                                    </span>
                                    )}
                                    <span className="selected-items-panel__chip-label overflow-hidden">
                                        {item?.Name || item?.Identifier}
                                    </span>
                                    <GMetrixButton
                                        className="selected-items-panel__chip-remove text-muted p-0"
                                        onClick={() => onRemove(item)}
                                        title={isAssigned ? formatMessage({ id: 'remove_assignment.93640c64', defaultMessage: 'Remove assignment' }) : formatMessage({ id: 'remove.d34ac1e7', defaultMessage: 'Remove' })}
                                        variant="link"
                                    >
                                        <i className="fa-solid fa-xmark" />
                                    </GMetrixButton>
                                </span>
                            );

                        })}
                    </div>
                )
            }

        </div>
    );

};
